import axios from 'axios'
import { coreClient, getToken } from '@/api/coreclient'
import type { TemplateAIAttributes } from 'common'

const apiUrl = import.meta.env.VITE_API_URL

export default {
  async fillExcel(
    body: unknown,
    useDevFile: boolean = false,
    hiddenTabs?: string,
    deletedTabs?: string
  ) {
    const token = await getToken()

    let url = '/templater/excel'

    if (useDevFile) {
      url += '?useDevFile=true'
    }

    return axios.post(apiUrl + url, body, {
      responseType: 'blob',
      params: {
        hiddenTabs,
        deletedTabs
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  }
}
